export const PreviewPanelAris = {
	goal: /ari:cloud:townsquare:[A-z0-9\-]+:goal\/[A-z0-9\-]+/,
};
